import { render, staticRenderFns } from "./DataPageComponent.vue?vue&type=template&id=40cf61a7&scoped=true"
import script from "./DataPageComponent.vue?vue&type=script&lang=js"
export * from "./DataPageComponent.vue?vue&type=script&lang=js"
import style0 from "./DataPageComponent.vue?vue&type=style&index=0&id=40cf61a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40cf61a7",
  null
  
)

export default component.exports